import React from 'react';
import { useGetPermissionsQuery } from '../../../services/organizations/organizations.service';

const usePermissionTree = () => {
    const { data: permissions, isLoading } = useGetPermissionsQuery('2');
    return { permissions, isLoading };
};

export default usePermissionTree;
